import Vue from 'vue';
import Router from 'vue-router';

import iView from 'iview';

Vue.use(iView);


Vue.use(Router);

// eslint-disable-next-line import/prefer-default-export
export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: '技术指标可视化导航',
      component: resolve => require(['@/views/greet.vue'], resolve),
    },
    {
      path: '/homeNav',
      name: '技术指标可视化导航',
      component: resolve => require(['@/views/homeNav.vue'], resolve),
    },
    {
      path: '/technicalNav',
      name: '技术指标可视化导航',
      component: resolve => require(['@/views/technical/technicalNav.vue'], resolve),
      children: [
        {
          path: '/home',
          name: 'K线图',
          component: resolve => require(['@/views/Home.vue'], resolve)
        },
        {
          path: '/picture',
          name: '副图指标',
          component: resolve => require(['@/views/technical/picture.vue'], resolve),
        },
        {
          path: '/mastermap',
          name: '主图指标',
          component: resolve => require(['@/views/technical/mastermap.vue'], resolve),
        },
        
      ]
    },
    {
      path: '/popup',
      name: '说明介绍',
      component: resolve => require(['@/views/technical/popup.vue'], resolve),
    },
    {
      path: '/factorAnalysisNav',
      name: '因子分析',
      component: resolve => require(['@/views/factorAnalysis/factorAnalysisNav.vue'], resolve),
    },
 
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/views/login.vue'], resolve)
      // component: () => import('@/views/login.vue'),
    },
    {
      path: '/404',
      name: 'error-404',
      component: resolve => require(['@/views/404.vue'], resolve)
      // component: () => import('@/views/404.vue'),
    },
    {
      path: '/technical',
      name: '技术指标可视化',
      // component: () => import('@/views/technical/index'),
      component: resolve => require(['@/views/technical/index'], resolve),
      children: [
        {
          path: 'timesharing',
          name: '分时图',
          // component: () => import('@/views/technical/timesharing.vue'),
          component: resolve => require(['@/views/technical/timesharing.vue'], resolve),
        },
        {
          path: 'picture',
          name: '副图指标',
          component: resolve => require(['@/views/technical/picture.vue'], resolve),
        },
        {
          path: 'mastermap',
          name: '主图指标',
          component: resolve => require(['@/views/technical/mastermap.vue'], resolve),
        },
      ]
    },
    {
      path: '/factorAnalysis',
      name: '因子分析',
      component: resolve => require(['@/views/factorAnalysis/index'], resolve),
      children: [
        {
          path: 'aloneanalysis',
          name: '单因子分析',
          // component: () => import('@/views/factorAnalysis/aloneanalysis.vue'),
          component: resolve => require(['@/views/factorAnalysis/aloneanalysis.vue'], resolve),

        },
        {
          path: 'multiplefactor',
          name: '单天、多因子、多标的分析',
          // component: () => import('@/views/factorAnalysis/multiple-factor.vue'),
          component: resolve => require(['@/views/factorAnalysis/multiple-factor.vue'], resolve),

        },
        {
          path: 'singleanalysis',
          name: '单天、单因子、多标的分析',
          // component: () => import('@/views/factorAnalysis/singleanalysis.vue'),
          component: resolve => require(['@/views/factorAnalysis/singleanalysis.vue'], resolve),

        },
        {
          path: 'singlefactor',
          name: '单标因子分析',
          // component: () => import('@/views/factorAnalysis/singlefactor.vue'),
          component: resolve => require(['@/views/factorAnalysis/singlefactor.vue'], resolve),

        },
      ]
    },
    {
      path: '/experimentNav',
      name: '分金融市场导航',
      component: resolve => require(['@/views/strategy/experimentNav.vue'], resolve),
    },
    {
      path: '/experiment/:id',
      name: '金融市场整体策略实验',
      component: resolve => require(['@/views/strategy/experiment.vue'], resolve),
    },
    {
      path: '/score',
      name: '综合评分',
      component: resolve => require(['@/views/strategy/score.vue'], resolve),
    },

  ],
});


